import tenantImprovementProjects from './projects'
import tenantImprovementProjectAllowance from './projectAllowance'
import tenantImprovementDocuments from './documents'

export default {
  tenantImprovementProjects,
  tenantImprovementProjectAllowance,
  tenantImprovementDocuments,
}
